import type { ExplorationTrailEntry } from '../lib/exploration-trail.js';

type ExplorationTrailProps = {
  entries: readonly ExplorationTrailEntry[];
  onJump: (entryId: string) => void;
  onClear: () => void;
};

export function ExplorationTrail({ entries, onJump, onClear }: ExplorationTrailProps) {
  if (entries.length === 0) {
    return null;
  }

  return (
    <nav className="exploration-trail" aria-label="Your exploration trail">
      <div className="exploration-trail__heading">
        <div>
          <p className="eyebrow">Your trail</p>
          <p>Only in memory for this page session.</p>
        </div>
        <button className="button button--small" type="button" onClick={onClear}>
          Clear trail
        </button>
      </div>
      <ol>
        {entries.map((entry) => (
          <li key={entry.id}>
            <button type="button" onClick={() => onJump(entry.id)}>
              <span>{entry.displayLabel}</span>
              <small>
                {entry.kind === 'person'
                  ? 'Person'
                  : `${entry.stepCount} relationship ${entry.stepCount === 1 ? 'step' : 'steps'}`}
              </small>
            </button>
          </li>
        ))}
      </ol>
    </nav>
  );
}
